// extracted by mini-css-extract-plugin
export var list = "skillList-module--list--qTmsC";
export var skill = "skillList-module--skill--A8LNy";
export var skillIcon = "skillList-module--skillIcon--cYabF";